export default {"src":"/_next/static/image/public/images/product-card-default.ad84b66fc7f72d41a207f4659031e760.svg","height":40,"width":75};